import React from 'react';
import { TestSummaryStatistics as TestSummaryStatisticsType } from '../TestExecution/const/TestSummary';
import styles from './TestSummaryStatistics.module.css';

interface TestSummaryStatisticsProps {
  statistics: TestSummaryStatisticsType;
  isDialog?: boolean
}

const TestSummaryStatistics: React.FC<TestSummaryStatisticsProps> = ({ statistics, isDialog }) => {
  return (
    <div className={styles.statisticsContainer}>
      <div className="kpi">
        <div className="color-gray">Test Cases</div>
        <div className="item text-xl">{statistics.total_executed}</div>
        <div>
          <span className="color-text">Executed</span>
        </div>
      </div>

      <div className="kpi">
        <div className="color-gray">Test Cases</div>
        <div className="item text-xl">{statistics.success_count}</div>
        <div>
          <span className="color-green">
            <i className="icon icon-top icon-alarm-level4"></i>
          </span>
          <span className="color-text"> Successful</span>
        </div>
      </div>

      <div className="kpi">
        <div className="color-gray">Test Cases</div>
        <div className="item text-xl">{statistics.failed_count}</div>
        <div>
          <span className="color-red">
            <i className="icon icon-top icon-alarm-level4"></i>
          </span>
          <span className="color-text"> Failed</span>
        </div>
      </div>

      {isDialog && 
        <div className="kpi">
          <div className="color-gray">Test Cases</div>
          <div className="item text-xl">{statistics.skipped_count}</div>
          <div>
            <span className="color-yellow">
              <i className="icon icon-top icon-alarm-level4"></i>
            </span>
            <span className="color-text"> Skipped</span>
          </div>
        </div>
      }

      {!isDialog && 
        <>
          <div className="kpi">
            <div className="color-gray">Test Cases Rate</div>
            <div className="item text-xl">{statistics.success_rate} %</div>
            <div>
              <span className="color-green">
                <i className="icon icon-top icon-alarm-level4"></i>
              </span>
              <span className="color-text"> Successful</span>
            </div>
          </div>

          <div className="kpi">
            <div className="color-gray">Test Cases Rate</div>
            <div className="item text-xl">{statistics.failed_rate} %</div>
            <div>
              <span className="color-red">
                <i className="icon icon-top icon-alarm-level4"></i>
              </span>
              <span className="color-text"> Failed</span>
            </div>
          </div>

          <div className="kpi">
            <div className="color-gray">Test Cases Rate</div>
            <div className="item text-xl">{statistics.skipped_rate} %</div>
            <div>
              <span className="color-yellow">
                <i className="icon icon-top icon-alarm-level4"></i>
              </span>
              <span className="color-text"> Skipped</span>
            </div>
          </div>
        </>
      }
    </div>
  );
};

export default TestSummaryStatistics;
